import { Module } from "plugins/_application"
import Glide from '@glidejs/glide'
import { debounce } from '../utils/_debounce'
import { toggleClass, hasClass, removeClass, addClass } from '../utils/_class-handlers'

const $ = jQuery

export default class FrontpageSlider extends Module {
  ready (app) {
    const SLIDER_CONTAINERS = document.querySelectorAll('.mtt-cover-image')

    if (SLIDER_CONTAINERS.length) {
      for (let i = 0; i < SLIDER_CONTAINERS.length; i++) {
        const SLIDER_CONTAINER = SLIDER_CONTAINERS[i]
        const GLIDE = SLIDER_CONTAINER.querySelector('.glide')
        const SLIDE_WRAPPER = SLIDER_CONTAINER.querySelector('.glide__slides')
        const GLIDE_SLIDES = SLIDER_CONTAINER.querySelectorAll('.glide__slide')
        const COUNT = SLIDER_CONTAINER.querySelectorAll('.glide__slide').length
        const ARROW_LEFT = SLIDER_CONTAINER.querySelector('.glide__arrows .glide__arrow--left')
        const ARROW_RIGHT = SLIDER_CONTAINER.querySelector('.glide__arrows .glide__arrow--right')

        // Is glide present?
        if (GLIDE && GLIDE_SLIDES.length) {
          const SLIDER = new Glide(GLIDE, {
            type: 'carousel',
            startAt: 0,
            perView: 1,
            gap: 0,
            autoplay: 7000,
            hoverpause: true,
            animationDuration: 700,
            keyboard: false
          }).mount()

          // Is slider slidable?
          this.isSlidable(SLIDER, COUNT)

          // Update arrows when slider is run
          SLIDER.on('run', () => {
            this.arrowHandler(SLIDER, COUNT, ARROW_LEFT, ARROW_RIGHT)
          })
        }
      }
    }
  }

  /**
   *
   * @param {Object} SLIDER
   * @param {Element} GLIDE_SLIDES
   * @param {Element} SLIDER_WRAPPER
   */
  setContainerHeight (SLIDER, GLIDE_SLIDES, SLIDER_WRAPPER, animate = true) {
    if (!SLIDER_WRAPPER) { return }

    // Get height of active slide
    const slideHeight = GLIDE_SLIDES[SLIDER._i].getBoundingClientRect().height

    if (animate) {
      // Animate height of slider wrapper
      setTimeout(() => {
        $('.frontpage_slides').animate({
          maxHeight: slideHeight
        }, 450, 'swing')
      }, 350)
    } else {
      // Set height of slider wrapper
      SLIDER_WRAPPER.style.maxHeight = slideHeight + 'px'
    }
  }

  /**
     * Checks if slider has enough slides to slide
     * @param {object} SLIDER
     * @param {int} COUNT
     */
  isSlidable (SLIDER, COUNT) {
    if (SLIDER) {
      // If there's not more items than perview
      if (COUNT <= SLIDER._o.perView) {
        // Disable slider if not disabled
        if (!SLIDER.disabled) {
          SLIDER.disable()
        }
      } else {
        // Enable slider if not enabled
        if (SLIDER.disabled) {
          SLIDER.enable()
        }
      }
    }
  }

  /**
     * Handler for arrows
     * @param {object} SLIDER
     * @param {int} COUNT
     * @param {el} ARROW_LEFT
     * @param {el} ARROW_RIGHT
     */
  arrowHandler (SLIDER, COUNT, ARROW_LEFT, ARROW_RIGHT, CLASS = 'disabled') {
    // Check if arrows exists
    if (ARROW_LEFT && ARROW_RIGHT) {
      // Check if slider is at the beginning
      if (SLIDER._i === 0) {
        addClass(ARROW_LEFT, CLASS)
        removeClass(ARROW_RIGHT, CLASS)
      } else if (SLIDER._i + SLIDER._o.perView === COUNT) { // Check if slider is at the end
        removeClass(ARROW_LEFT, CLASS)
        addClass(ARROW_RIGHT, CLASS)
      } else { // Check if slider is in the middle
        removeClass(ARROW_LEFT, CLASS)
        removeClass(ARROW_RIGHT, CLASS)
      }
    }
  }

  /**
     * Get screen width
     */
  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }
}
